import * as yup from 'yup'
import { t } from 'translations'

export const poiValidationSchema = yup.object().shape({
    status: yup.string().required(() => t('common.validation.required')),
    lat: yup.number().required(() => t('common.validation.required')),
    lng: yup.number().required(() => t('common.validation.required')),
    content: yup.array(
        yup.object({
            locale: yup.string().required(() => t('common.validation.required')),
            name: yup.string().required(() => t('common.validation.required')),
        }),
    ),
})
